import { render, staticRenderFns } from "./withdraw-intro.vue?vue&type=template&id=e569cbea&scoped=true"
import script from "./withdraw-intro.vue?vue&type=script&lang=js"
export * from "./withdraw-intro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e569cbea",
  null
  
)

export default component.exports